/* Admin view-as (issue 2902) · MUST be the first import of main.tsx. Importing it runs the install: it reads the
   #rvva handoff, swaps window.localStorage for a tab-private store, forces the Bearer-only fetch and turns the
   beacons off BEFORE any other module can read or write the owner's storage. A no-op in an ordinary tab.
   See packages/client/src/viewAs.ts. */
import { installViewAsRuntime } from '@territory/client/viewAs';

export const VIEW_AS_STATE = installViewAsRuntime();
